import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { startCase } from 'lodash';

import { EngineSubstepsEnum } from '@/store/Engine/constants';
import { useStores } from '@/hooks/use-stores';

import FlowLevelsTable from './FlowLevelsTable';
import PressureRangesTable from './PressureRangesTable';
import { ResultContainer } from './styled';

const Result = observer(({ selectedSubstepName }: { selectedSubstepName?: EngineSubstepsEnum }) => {
  const { t } = useTranslation();
  const { engineStore } = useStores();

  return (
    <ResultContainer $hasFinishedWizard={engineStore.hasFinishedWizard}>
      <span className="flow-range">{startCase(t('Flow Levels'))}</span>
      <FlowLevelsTable selectedSubstepName={selectedSubstepName} />
      <span className="flow-range">{startCase(t('pressureRanges'))}</span>
      <PressureRangesTable selectedSubstepName={selectedSubstepName} />
    </ResultContainer>
  );
});

export default Result;
